import React from "react";
import { Circles } from "react-loader-spinner"
import { UserContext } from "../utils";
import { useContext } from "react";
import classNames from "classnames";

export default function ServiceThreadSpinner({
  on,
  children,
  white,
  small,
  left,
  ...props
}) {
  const userCtx = useContext(UserContext);
  const { theme } = userCtx;
  let color = theme === "darkTheme" ? "#f76f1e" : "#2b72b9";
  let height = 120;
  let width = 120;
  if (white) color = "#FFFFFF";
  if (small) {
    height = 30;
    width = 30;
  }
  if (on) {
    return (
      <div className={classNames("text-center", { "float-start": left })}>
        <div style={{ display: "block", margin: "auto", width: "130px" }}>
          <Circles
            color={color}
            height={height}
            width={width}
            timeout={50000}
          />
        </div>
      </div>
    );
  }
  return children;
}
